<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">
    <el-row style="padding: 20px;height: 100%;">
      <el-table
        :data="doorLogs.records"
        height="100%"
        border
        class="m-auto"
        style="width: 100%;">
        <el-table-column
          align="center"
          label="门点名称"
          prop="area"
         >
        </el-table-column>
        <el-table-column
          align="center"
          label="人员名称"
          prop="name">
        </el-table-column>
        <el-table-column
          align="center"
          label="设备"
          prop="door">
        </el-table-column>
        <el-table-column
          align="center"
          label="名称动作事件结果"
          prop="eventResultName">
        </el-table-column>
        <el-table-column
          align="center"
          label="动作事件触发动作"
          prop="eventActionWayName">
        </el-table-column>
        <el-table-column
          align="center"
          label="验证方式"
          prop="verifyTypeName">
        </el-table-column>
        <el-table-column
          align="center"
          label="进出标识"
          prop="log">
        </el-table-column>
        <el-table-column
          align="center"
          label="凭据类型"
          prop="typeName">
        </el-table-column>
        <el-table-column
          align="center"
          label="事件发生时间"
          prop="time">
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      :current-page="doorLogs.current" :hide-on-single-page="true"
      :page-size="doorLogs.size"
      :small="true"
      :total="doorLogs.total"
      class="mb-4 mt-3 text-center"
      layout="prev, pager, next"
      style="padding-left: 35px;width: 92%;"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>

<script>
import {getHikvisionAccessControl, } from "@/network/entranceguard";

export default {
  name: "DasDoor",
  props: ['deviceInfo'],
  data() {
    return {
      // 开门记录
      doorLogs: {},
      page: {
        data: {
          max: 10,
          index: 1
        }
      }
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.40
    }
  },
  mounted() {
    this.getData(this.page.data.index, this.page.data.max, this.deviceInfo.id)
  },
  methods: {
    getData(index, max, id) {
      getHikvisionAccessControl(index, max, id).then(res => {
        if (res.code === 0) {
          this.doorLogs = res.data
        }
      })
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.deviceInfo.id)
    },
  }
}
</script>

<style scoped>
::v-deep .el-table th.el-table__cell{
  background: rgba(41, 155, 255, .3);
}
</style>
